import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { CartItem } from "../components/CartItem";
import { CartSummary } from "../components/CartSummary";
import { Button } from "../components/Button";
import { usePageTitle } from "../hooks/usePageTitle";

export function Cart() {
  usePageTitle("Shopping Cart");
  const { items } = useCart();

  if (items.length === 0) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
        <h1 className="text-3xl font-bold mb-4">Your cart is empty</h1>
        <p className="text-gray-600 mb-8">
          Start shopping to add items to your cart
        </p>
        <Link to="/">
          <Button variant="primary">Continue Shopping</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-8">Shopping Cart</h1>

      <div className="grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <div className="bg-white rounded-lg shadow">
            {items.map((item) => (
              <CartItem key={item.product.id} item={item} />
            ))}
          </div>
          <Link to="/" className="inline-block mt-4 text-blue-600 hover:underline">
            ← Continue Shopping
          </Link>
        </div>

        <div>
          <CartSummary />
        </div>
      </div>
    </div>
  );
}
